import Main from "./components/Main";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

function App() {
	return (
		<>
			<Main />
			<Skills />
			<Projects />
		</>
	);
}

export default App;
